export default {
  NOTIFICATION_EDIT_REQUEST: 'APP/NOTIFICATION/NOTIFICATION_EDIT_REQUEST',
  NOTIFICATION_EDIT_SUCCESS: 'APP/NOTIFICATION/NOTIFICATION_EDIT_SUCCESS',
  NOTIFICATION_EDIT_ERROR: 'APP/NOTIFICATION/NOTIFICATION_EDIT_ERROR',
};
